import routes from './routes';
import { createWebHashHistory, createRouter } from 'vue-router';
import FluentFramework from './Bits/FluentFramework';
var router = createRouter({
  history: createWebHashHistory(),
  routes: routes
});
var framerwork = new FluentFramework();
framerwork.app.config.globalProperties.appVars = window.fluentFrameworkAdmin;
window.fluentFrameworkApp = framerwork.app.use(router).mount('#fconnector_app');
router.afterEach(function (to, from) {
  jQuery('.fframe_menu_item').removeClass('fs_active');
  var active = to.meta.active;
  if (active) {
    jQuery('.fframe_main-menu-items').find('li[data-key=' + active + ']').addClass('fs_active');
  }
});